import { Skeleton } from "./Skeleton";

// Inner Suspense fallback for lazy route chunks. Renders inside the layout
// shell (sidebar/topbar already visible) so the page swap doesn't flash the
// full-screen PageLoader gradient. Generic page-shaped skeleton — works
// well enough across portal pages during the brief chunk-load window.
export const RouteFallback = () => (
  <div className="space-y-4">
    <Skeleton className="h-7 w-1/3 max-w-xs" />
    <Skeleton className="h-4 w-1/2 max-w-md" />
    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton key={i} className="h-32 w-full" />
      ))}
    </div>
  </div>
);
